export enum TypeBooks {
	SELECIONE = 'Selecione',
	COLECAO = 'Coleção',
	LIVRO_AVULSO = 'Livro Avulso',
}
